"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivacyPolicy = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PrivacyPolicy = ({
  text,
  linkText,
  url
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const LINK_PLACE = '{0}';
  const splitText = text.split(LINK_PLACE);
  if (!text || !linkText) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.PRIVACY_POLICY),
    component: "div",
    variant: "caption",
    children: [splitText[0], /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
      href: url,
      target: "_blank",
      rel: "noopener noreferrer",
      children: linkText
    }), splitText[1]]
  });
};
exports.PrivacyPolicy = PrivacyPolicy;